import React from 'react';
import { connect } from 'react-redux';
import { Sidebar } from 'shared/containers/portal_layout';
import { newReferralButtonClicked } from '../../../actions/NewReferralActions';

const ProviderSidebarLinks = ({ dispatch, currentEmployment, pendingReferralsCount }) => (
  <Sidebar>
    <Sidebar.NavLink path="/a/portal/dashboard" label="Dashboard" icon="home" />
    <Sidebar.NavLink
      path="/a/portal/passive_app_notifications/unread"
      label="Notifications"
      icon="bullhorn"
    />
    <Sidebar.NavLink path="/a/portal/cost_estimates/new" label="Cost Estimate" icon="barcode" />

    <Sidebar.NavLink path={`/a/calendar`} label="Calendar" icon="calendar" />
    {/*
        <Sidebar.NavLink
          path={`/a/calendar`}
          label="Calendar"
          icon="calendar"
        */}
    <Sidebar.Submenu icon="drawer2" label="Referrals" numberBadge={pendingReferralsCount}>
      <Sidebar.Submenu.NavFakeLink
        onClick={() => dispatch(newReferralButtonClicked())}
        label="Create Referral"
      />
      <Sidebar.Submenu.NavLink path={`/a/portal/referrals`} label="My Referrals" />
    </Sidebar.Submenu>
    <Sidebar.NavLink
      path="/a/portal/eligibility_checks/new"
      label="Eligibility Check"
      icon="coin-dollar"
    />
    {currentEmployment.features.indexOf('analytics') >= 0 && (
      <Sidebar.NavLink path={`/a/analytics`} label="Analytics" icon="graph" />
    )}
    <Sidebar.Submenu icon="gear" label="Manage">
      <Sidebar.Submenu.NavLink path={`/a/portal/providers/network`} label="Network" />
      <Sidebar.Submenu.NavLink
        path={`/a/portal/providers/insurance_rejections`}
        label="Acceptable Insurance"
      />
      <Sidebar.Submenu.NavLink
        path={`/a/portal/current_provider_employment/ruleset/edit`}
        label="Referral Rules"
      />
      {currentEmployment.organization.brandedPortalEnabled && (
        <Sidebar.Submenu.NavLink
          path="/a/portal/current_provider_employment/branded_ruleset/edit"
          label="Branded Referral Rules"
        />
      )}
    </Sidebar.Submenu>
  </Sidebar>
);

export default connect()(ProviderSidebarLinks);
